"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Payment = void 0;
var _checkoutPayment = require("@ori/checkout-payment");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _contexts = require("../../contexts");
var _models = require("../../models");
var _FormattedMessage = require("../FormattedMessage");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Payment = ()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    const configuration = (0, _contexts.useCheckout)();
    const { activeProviderId, continueButtonTooltip, billingState, isPaymentModelLoading, paymentModel, setActiveProviderId } = (0, _contexts.useNavigationContext)();
    if (billingState === 'disabled') {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.SectionWrapper, {
            inert: "",
            "data-testid": getTestId(_models.TestId.PaymentSection),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.SectionHeader, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.DisabledTitle, {
                    variant: "h6",
                    component: "h2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                        id: "payment"
                    })
                })
            })
        });
    }
    const showSkeleton = billingState === 'loading';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_checkoutPayment.CheckoutPayment, {
        ...(0, _checkoutPayment.getProps)({
            ...configuration,
            isSimplifiedCheckout: true
        }),
        activeProviderId: activeProviderId,
        continueButtonTooltip: continueButtonTooltip,
        isPaymentModelLoading: isPaymentModelLoading || showSkeleton,
        paymentModel: showSkeleton ? undefined : paymentModel,
        setActiveProviderId: setActiveProviderId
    });
};
exports.Payment = Payment;
